module.exports = __webpack_public_path__ + "static/media/text.a65c85b0.svg";